export function listSaveEditLabel(isEditing: boolean): string {
    return isEditing ? 'Save' : 'Edit';
}
